<h2>Map Brightcove’s external MAM to evrideo’s MAM</h2>
<label
  >Select reference field(s) to map metadata fields from another video</label
>
<mat-form-field appearance="outline" floatLabel="always">
  <mat-label>reference fields</mat-label>
  <mat-select
    #refrenceDropdown
    [value]="internalReferenceFields"
    multiple
    (openedChange)="
      this.showReferenceError = $event ? false : this.showReferenceError
    "
    (selectionChange)="updateReferenceMapping($event, refrenceDropdown)"
  >
    <mat-option *ngFor="let item of mappedOptions" [value]="item">{{
      item.displayName
    }}</mat-option>
  </mat-select>
</mat-form-field>
<span class="error-msg" [hidden]="!showReferenceError"
  >Can't remove reference variable that is in use.
</span>
<hr style="width: 100%" />

<form class="fields-container">
  <mat-form-field
    *ngFor="let kv of internalMappedFields | keyvalue"
    appearance="outline"
    floatLabel="always"
  >
    <mat-label> {{ kv.key }} </mat-label>
    <mat-select
      [value]="kv.value"
      (selectionChange)="updateFieldMapping(kv.key, $event)"
    >
      <mat-option>-- None --</mat-option>
      <mat-option *ngFor="let item of mappedOptions" [value]="item.id">{{
        item.displayName
      }}</mat-option>
      <mat-optgroup
        *ngFor="let reference of internalReferenceFields"
        [label]="reference.displayName"
        style="font-weight: 700; display: block"
      >
        <mat-option
          *ngFor="let item of mappedOptions"
          [value]="concateRefreneceIdAndVariable(reference.id, item.id)"
          style="font-weight: 400; display: block"
          >{{ reference.displayName }} / {{ item.displayName }}</mat-option
        >
      </mat-optgroup>
    </mat-select>
  </mat-form-field>
</form>
